<template>
  <!-- eslint-disable max-len -->
  <div class="form-group">
    <label v-if="label" :for="id">{{ $slots.default && $slots.default[0].text || '' }}&nbsp;&nbsp;<small v-if="!noCount" class="character-count">{{ value.length }}{{ typeof maxLength === 'number' ? ` / ${maxLength}` : '' }} characters</small></label>
    <div :class="{ 'input-group': remove || copyable }">
      <span v-if="false"><slot>Field</slot></span>
      <textarea
        v-if="textarea"
        :id="id"
        :name="name"
        :rows="rows || 5"
        :placeholder="placeholder || $slots.default[0].text.trim()"
        :value="value"
        @input="onInput"
        @change="onChange"
        type="text"
        class="form-control"
        :class="{ error: validator && validator.$error }"
        @focus="onFocus"
        @blur="onBlur"
        :disabled="disabled"
        v-focus="(value) ? false : autofocus"
      >
      </textarea>
      <input
        v-else
        :id="id"
        :name="name"
        :placeholder="placeholder || $slots.default[0].text.trim()"
        :value="value"
        @input="onInput"
        @change="onChange"
        :type="type"
        class="form-control"
        :class="{ error: validator && validator.$error }"
        @focus="onFocus"
        @blur="onBlur"
        :disabled="disabled"
        @keydown="(event) => { if (!submittable && event.keyCode == 13) { event.preventDefault(); return false; } }"
        v-focus="(value) ? false : autofocus"
        ref="textinput"
      />
      <div v-if="copyable" class="input-group-append">
        <button
          class="btn btn-sm"
          style="padding: 0 30px;"
          @click.prevent="copy">
          {{copySuccess ? 'Copied!' : 'Copy'}}
        </button>
      </div>
      <div v-if="remove" class="input-group-append">
        <button
          class="btn btn-sm"
          @click.prevent="remove">
          X
        </button>
      </div>
      <div v-if="down" class="input-group-append">
        <button
          class="btn btn-sm"
          @click.prevent="down">
          &#9660;
        </button>
      </div>
      <div v-if="up" class="input-group-append">
        <button
          class="btn btn-sm"
          @click.prevent="up">
          &#9650;
        </button>
      </div>
    </div>
    <template v-if="validator && validator.$error">
      <p class="error-msg" v-if="required && !validator.required">{{ modelText }} is required</p>
      <p class="error-msg" v-else-if="email && !validator.email">Email must be valid email</p>
      <p class="error-msg" v-else-if="minLength && !validator.minLength">{{ modelText }} must be {{ validator.$params.minLength.min }} characters or more</p>
      <p class="error-msg" v-else-if="maxLength && !validator.maxLength">{{ modelText }} must be {{ validator.$params.maxLength.max }} characters or less</p>
      <p class="error-msg" v-else-if="customError">{{ customError.message }}</p>
    </template>
  </div>
</template>

<script>
import { fixQuotes } from '../../../utils/text';

export default {
  props: {
    autofocus: { type: Boolean },
    confirmPassword: { type: Boolean },
    customErrors: { type: Array, default: () => [] },
    disabled: { type: Boolean },
    down: { type: Function },
    email: { type: Boolean },
    label: { type: Boolean },
    minLength: { type: Boolean },
    maxLength: { type: [Boolean, Number] },
    noCount: { type: Boolean },
    password: { type: Boolean },
    remove: { type: Function },
    required: { type: Boolean },
    rows: { type: Number },
    textarea: { type: Boolean },
    up: { type: Function },
    validator: { type: Object },
    value: { type: String, default: '' },
    copyable: { type: Boolean },
    submittable: { type: Boolean },
    placeholder: { type: String, default: '' }
  },
  data() {
    return {
      copySuccess: false
    };
  },
  computed: {
    customError() {
      return (this.customErrors || []).find(error => !this.validator[error.validator]);
    },
    id() {
      return this.email ? 'email' :
        this.password ? 'password' :
          this.confirmPassword ? 'confirm-password' :
            this._uid;
    },
    name() {
      return this.id;
    },
    type() {
      return this.email ? 'email' : (this.password || this.confirmPassword) ? 'password' : 'text';
    },
    modelText() {
      return this.email ? 'Email' : (this.password || this.confirmPassword) ? 'Password' : this.$slots.default[0].text;
    }
  },
  methods: {
    onFocus($event) {
      this.$emit('focus', $event);
    },
    onBlur($event) {
      if (this.validator) this.validator.$touch();
      this.$emit('blur', $event);
    },
    onInput($event) {
      if (this.validator) this.validator.$touch();
      this.$emit('input', fixQuotes($event.target.value));
    },
    onChange($event) {
      if (this.validator) this.validator.$touch();
      this.$emit('change', $event);
    },
    copy() {
      if (!navigator.clipboard) {
        this.copyFallback();
      } else {
        navigator.clipboard.writeText(this.value).then(() => {
          this.copySuccess = true;
          setTimeout(() => { this.copySuccess = false; }, 3500);
        }, (err) => {
          console.error(err);
          this.copyFallback();
        });
      }
    },
    copyFallback() {
      try {
        this.$refs.textinput.focus();
        this.$refs.textinput.select();
        this.copySuccess = document.execCommand('copy');
        setTimeout(() => { this.copySuccess = false; }, 3500);
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.character-count {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/inputs/TextInput.vue